<script>
  import {
    isMobile,
    allYears,
    windowWidth,
    windowHeight,
    isPortrait,
    currentYear,
    isSafari,
  } from "./stores/global.js";

  // Import components
  import Window from "./components/Window.svelte";
  import Eye from "./components/Icons/Eye.svelte";
  import QuestionMark from "./components/Icons/Question.svelte";
  import Key from "./components/Key/Key.svelte";
  import MobileKey from "./components/Key/MobileKey.svelte";
  import DesktopLayout from "./components/Layout/Desktop.svelte";
  import MobileLayout from "./components/Layout/Mobile.svelte";
  import Modal from "./components/Modal/Modal.svelte";
  import Minimap from "./components/Minimap/Minimap.svelte";

  // Import Swiper styles
  import "swiper/css";
  import "swiper/css/free-mode";
  import "swiper/css/scrollbar";

  import data from "./data/data.json";
  let exampleData = data.find((d) => d.title == "Allbirds founded");

  const years = [...new Set(data.map((d) => d.year))].reverse();
  allYears.set(years);

  let isCurrMobile = $isMobile;
  let isCurrPortrait = $isPortrait;

  $: updateCurrView = () => {
    setTimeout(() => {
      isCurrMobile = $isMobile;
      isCurrPortrait = $isPortrait;
    }, 50);
  };

  const reloadPage = function () {
    // If 'current' view is different from stores value
    if (isCurrMobile != $isMobile) {
      window.location.reload(true);
    }
    // On mobile devices, reload webpage
    if ($isMobile && $isPortrait != isCurrPortrait) {
      window.location.reload(true);
    }
  };

  $: customHeightProp = `--height-px: ${$windowHeight}px`;
  $: windowWidth, reloadPage(), updateCurrView();

  $: safari = $isSafari;

  console.log(
    "Interested in the technical side of things? Developed by the team at Moksha Data. Learn more at https://mokshadata.com/"
  );
</script>

<Window />
<Modal {exampleData} trigger={$currentYear == 2021} />
{#if $isMobile}
  <div id="mobile" class:safari style={customHeightProp}>
    <MobileKey />
    {#if $currentYear}
      <Eye width={20} height={20} />
      <QuestionMark size={20} />
      <Minimap {data} isMobile={true} />
    {/if}

    <MobileLayout {data} {years} {safari} />
  </div>
{:else}
  <div id="desktop" class:safari style={customHeightProp}>
    <Key />
    {#if $currentYear}
      <Eye width={20} height={20} />
      <QuestionMark size={20} />
      <Minimap {data} isMobile={false} />
    {/if}

    <DesktopLayout {data} {years} />
  </div>
{/if}

<style>
  :global(.swiper, .swiper-slide) {
    height: var(--height-px) !important;
  }

  :global(.swiper-slide:not(.swiper-slide-active) .slide) {
    z-index: 3 !important;
  }

  :global(.swiper-slide) {
    scroll-snap-align: start !important; /* FIXES CSS MODE DOING AUTOMATIC SNAPPING */
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
  }

  :global(.swiper-slide-active) {
    transform: translate3d(0, 0, 1px);
    -webkit-transform: translate3d(0, 0, 1px);
    z-index: 4;
  }

  :global(.safari .swiper-slide, .safari .swiper-slide-active) {
    transform: none;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  }

  /* Undo handling of Android transform properties */
  /* JUST UNDID */
  /* :global(.swiper-slide) {
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  } */

  :global(:not(.safari .swiper-wrapper) .swiper-wrapper) {
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
  }
</style>
